import { lazy } from 'react';
import ProtectedRoute from '../ProtectedRoute';
import { CatalogDetail } from '../../../widgets/catalog-detail';
import { FavoritesProvider } from '@features/add-product-to-favorites';
import { CatalogAddEdit } from '@features/catalog-add-edit';
const Catalog = lazy(() => import('../../../pages/Catalog/Catalog'));

export const catalog_routes = [
  {
    path: 'catalog',
    errorElement: <h1>404</h1>,
    element: <Catalog />,
    loader: () => {
      return document.title = 'Каталог';
    },
  },
  {
    path: 'catalog/:id',
    element: <FavoritesProvider><CatalogDetail /></FavoritesProvider>,
    loader: () => {
      return document.title = 'Товар';
    },
  },
  {
    path: 'catalog/edit/:id',
    element: (
      <ProtectedRoute
        isOnlySuperManager={true}
        action='change'
        subject={'card'}
        redirectTo={'/catalog'}
        children={
        <CatalogAddEdit />
      }
      />
    ),
    loader: () => {
      return document.title = 'Редактирование товара';
    },
  },
  {
    path: 'catalog/add',
    element: (
      <ProtectedRoute
        isOnlySuperManager={true}
        action='add'
        subject={'catalog'}
        redirectTo={'/catalog'}
        children={
        <CatalogAddEdit />
      }
      />
    ),
    loader: () => {
      return document.title = 'Редактирование товара';
    },
  },
];
